var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('HelloWorld',{attrs:{"msg":"Contenu de la formation","urlimage":"contenu_formation.png"}}),_c('contenuformation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }